/* Movatic WMS – Frontend | API Core (Companies) */
import { http } from '@/lib/http'

export type Company = { id: number; code: string; name: string }

export async function listCompanies() {
    const res = await http.get<{ results?: Company[] } | Company[]>('/api/core/companies/', {
        params: { page_size: 200 }
    })
    const data = res.data as any
    return Array.isArray(data) ? data : (data?.results ?? [])
}
